import { KPI_STATE } from '../../components/Modals/DashboardModal/constants';
import { ModalitiesProps } from '../../components/Modals/DashboardModal/dashboardModalInterface';
import { TreeItem } from '../../components/SortableTree/types';
import { colors } from '../../theme/colors';
import { DraggableEntities } from '../DraggableEntities/DraggableEntities';

export default class Modality implements ModalitiesProps, DraggableEntities {
    codemodalite: number;

    label: string;

    hide?: boolean;

    excluded?: boolean;

    fillColor?: string;

    constructor({ codemodalite = 0, label = '', hide, excluded, fillColor = colors.blue000 }: ModalitiesProps) {
        this.codemodalite = codemodalite;
        this.label = label;
        this.hide = hide;
        this.excluded = excluded;
        this.fillColor = fillColor;
    }

    toModalitiesProps(): ModalitiesProps {
        return { codemodalite: this.codemodalite, label: this.label, excluded: this.excluded, hide: this.hide ?? this.excluded, fillColor: this.fillColor };
    }

    toTreeItem(): TreeItem {
        return {
            id: this.codemodalite,
            label: this.label,
            isGroupale: false,
            children: [],
            fillColor: this.fillColor,
        };
    }

    getStatus(): KPI_STATE | null {
        return (this.excluded ? KPI_STATE.EXCLUDED : null) ?? (this.hide ? KPI_STATE.HIDDEN : null);
    }

    copyWith({ label, hide, excluded, fillColor }: ModalitiesProps): Modality {
        return new Modality({
            codemodalite: this.codemodalite,
            label: label ?? this.label,
            hide: hide ?? this.hide,
            excluded: excluded ?? this.excluded,
            fillColor: fillColor ?? this.fillColor,
        });
    }
}
